import { isString } from 'lodash';
import { FieldOptionBase } from 'api/tasks';
import { logger } from 'services';

/**
 *
 * @description This function is used to get the value of an object containing value and valueStr.
 *  If the casted value is a NaN, return string value, else return the casted value.
 *  Primarily used after sharding changes.
 */
export const getValueStrOrValueAsNumber = (box: FieldOptionBase<any>) => {
  try {
    // In some constructed fields like Inferred Progress and Current Progress, value is a string
    // and in the src/components/organisms/tasks/filters/multi-select.ts parse function, we are casting it to a number. If the value is something like '1 Phase'
    // it gets converted to number 1 in the function in this function., which can be matched to an actual number. Before this bug
    // currentPhases filter didn't work at all.
    if (isString(box.value)) {
      return box.value;
    }

    const boxValue = box.valueStr ?? box.value;
    const returnVal = Number(boxValue);

    return Number.isNaN(returnVal) ? boxValue : returnVal;
  } catch (e: any) {
    logger.error(
      'Error while casting value from string to number in criterion',
      e,
    );

    return box.valueStr ?? box.value;
  }
};
